!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports) : "function" == typeof define && define.amd ? define(["exports"], n) : n((e = "undefined" != typeof globalThis ? globalThis : e || self).FEIM = {});
}(this, function (e) {
  "use strict";

  var n = function () {
    return n = Object.assign || function (e) {
      for (var n, o = 1, t = arguments.length; o < t; o++) for (var a in n = arguments[o]) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
      return e;
    }, n.apply(this, arguments);
  };
  function o(e, n, o, t) {
    return new (o || (o = Promise))(function (a, i) {
      function r(e) {
        try {
          c(t.next(e));
        } catch (e) {
          i(e);
        }
      }
      function s(e) {
        try {
          c(t.throw(e));
        } catch (e) {
          i(e);
        }
      }
      function c(e) {
        var n;
        e.done ? a(e.value) : (n = e.value, n instanceof o ? n : new o(function (e) {
          e(n);
        })).then(r, s);
      }
      c((t = t.apply(e, n || [])).next());
    });
  }
  function t(e, n) {
    var o,
      t,
      a,
      i = {
        label: 0,
        sent: function () {
          if (1 & a[0]) throw a[1];
          return a[1];
        },
        trys: [],
        ops: []
      },
      r = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return r.next = s(0), r.throw = s(1), r.return = s(2), "function" == typeof Symbol && (r[Symbol.iterator] = function () {
      return this;
    }), r;
    function s(s) {
      return function (c) {
        return function (s) {
          if (o) throw new TypeError("Generator is already executing.");
          for (; r && (r = 0, s[0] && (i = 0)), i;) try {
            if (o = 1, t && (a = 2 & s[0] ? t.return : s[0] ? t.throw || ((a = t.return) && a.call(t), 0) : t.next) && !(a = a.call(t, s[1])).done) return a;
            switch (t = 0, a && (s = [2 & s[0], a.value]), s[0]) {
              case 0:
              case 1:
                a = s;
                break;
              case 4:
                return i.label++, {
                  value: s[1],
                  done: !1
                };
              case 5:
                i.label++, t = s[1], s = [0];
                continue;
              case 7:
                s = i.ops.pop(), i.trys.pop();
                continue;
              default:
                if (!(a = i.trys, (a = a.length > 0 && a[a.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                  i = 0;
                  continue;
                }
                if (3 === s[0] && (!a || s[1] > a[0] && s[1] < a[3])) {
                  i.label = s[1];
                  break;
                }
                if (6 === s[0] && i.label < a[1]) {
                  i.label = a[1], a = s;
                  break;
                }
                if (a && i.label < a[2]) {
                  i.label = a[2], i.ops.push(s);
                  break;
                }
                a[2] && i.ops.pop(), i.trys.pop();
                continue;
            }
            s = n.call(e, i);
          } catch (e) {
            s = [6, e], t = 0;
          } finally {
            o = a = 0;
          }
          if (5 & s[0]) throw s[1];
          return {
            value: s[0] ? s[1] : void 0,
            done: !0
          };
        }([s, c]);
      };
    }
  }
  "function" == typeof SuppressedError && SuppressedError;
  var a,
    i,
    r = {},
    s = function () {
      return r;
    },
    c = function () {
      var e, n;
      return r.clientConfig ? r.clientConfig.devMode ? "*" : null !== (e = r.clientConfig.targetOrigin) && void 0 !== e ? e : "*" : r.p2pConfig ? null !== (n = r.p2pConfig.targetOrigin) && void 0 !== n ? n : "*" : "-";
    },
    u = function (e, n) {
      var o;
      if (!0 === (null === (o = r.clientConfig) || void 0 === o ? void 0 : o.devMode)) return !0;
      var t = c();
      return !(!n || "*" !== t) || e === t || e === window.location.origin;
    },
    d = function () {
      return void 0 !== r.clientConfig || void 0 !== r.p2pConfig;
    },
    l = "" === (a = window.location.search) ? {} : a.slice(a.indexOf("?") + 1).split("&").reduce(function (e, o) {
      var t,
        a,
        i = o.indexOf("=");
      if (i < 0) return n(n({}, e), ((t = {})[o] = "true", t));
      var r = o.slice(0, i),
        s = o.slice(i + 1);
      return n(n({}, e), ((a = {})[r] = decodeURIComponent(s), a));
    }, {}),
    E = function (e) {
      var n, o;
      if (void 0 !== l[e]) return l[e];
      var t = null === (o = null === (n = s().p2pConfig) || void 0 === n ? void 0 : n.launchParams) || void 0 === o ? void 0 : o[e];
      return void 0 !== t ? l[t] : void 0;
    },
    f = function (e) {
      return Object.prototype.hasOwnProperty.call(l, e);
    };
  e.LogLevel = void 0, (i = e.LogLevel || (e.LogLevel = {}))[i.NONE = 0] = "NONE", i[i.ERROR = 1] = "ERROR", i[i.WARN = 2] = "WARN", i[i.INIT = 3] = "INIT", i[i.ALL_MESSAGES = 4] = "ALL_MESSAGES", i[i.ALL_MESSAGES_AND_PAYLOADS = 5] = "ALL_MESSAGES_AND_PAYLOADS";
  var g = f("rlxfeimdebug"),
    p = e.LogLevel.ERROR;
  g && (p = e.LogLevel.ALL_MESSAGES_AND_PAYLOADS);
  var _,
    v,
    A = function (e) {
      g && window.rlxfeim.log.push(e);
    },
    S = function (n, o, t) {
      void 0 === o && (o = e.LogLevel.ALL_MESSAGES), p >= o && (void 0 !== t && (p >= e.LogLevel.ALL_MESSAGES_AND_PAYLOADS || o <= e.LogLevel.INIT) && (n += " " + JSON.stringify(t)), A(n), console.log("%c[FEIM]%c".concat(n), "color: #000; margin-right: 4px; background: #a0ecff; padding: 2px 6px; border: 1px solid #888", function (n) {
        return n <= e.LogLevel.INIT ? "color: #000; background: #a0ecff; padding: 2px 6px; border: 1px solid #888" : "color: #000; background: #d9e3e6; padding: 2px 6px;";
      }(o)));
    },
    I = function (n, o) {
      void 0 === o && (o = e.LogLevel.WARN), p >= o && (A(n), console.warn("[FEIM] ".concat(n)));
    },
    T = function (n) {
      p > e.LogLevel.NONE && (A(n), console.error("[FEIM] ".concat(n)));
    };
  !function (e) {
    e.LISTENING = "game-listening", e.HELLO = "game-hello", e.CONFIGURE = "configure", e.REALITY_CHECK_RESOLVED = "rc-resolved", e.PAUSED = "idle-paused", e.RESUMING_AFTER_PAUSE = "pause-resumed", e.REPORT_SESSION_DETAILS = "rc-session-details", e.GAME_LOAD_STARTED = "game-load-started", e.GAME_LOAD_PROGRESS = "game-load-progress", e.GAME_LOAD_COMPLETED = "game-load-loaded", e.GAME_READY_TO_PLAY = "game-ready-to-play", e.ROUND_STARTED = "game-round-started", e.ROUND_FINISHED = "game-round-finished", e.ROUND_RESUMED = "game-round-resumed", e.FEATURE_STARTED = "feature-started", e.FEATURE_FINISHED = "feature-finished", e.REQUEST_VIEWPORT_CONFIG = "game-request-viewport-config", e.BALANCE_UPDATE = "balance-update", e.BET_UPDATE = "bet-update", e.WIN_UPDATE = "win-update", e.UPDATE_SETTINGS = "settings-changed", e.ERROR_MESSAGE = "error-message", e.EXIT_GAME = "exit-game", e.AUTOPLAY_STARTED = "autoplay-started", e.AUTOPLAY_FINISHED = "autoplay-finished", e.GOTO_GAME = "goto-game", e.OPEN_QUICK_DEPOSIT = "open-quick-deposit", e.USER_ACTION = "user-action", e.REPORT_UI_STATE = "report-ui-state", e.JACKPOT_ANIMATION_STARTED = "jackpot-animation-started", e.JACKPOT_ANIMATION_FINISHED = "jackpot-animation-finished";
  }(_ || (_ = {})), function (e) {
    e.LISTENING = "listening", e.HELLO = "hello", e.REFRESH_BALANCE = "update-balance", e.UPDATE_SETTINGS = "settings-update", e.PAYTABLE_TOGGLE = "toggle-paytable", e.ERROR_MESSAGE_DISMISSED = "error-message-dismissed", e.VIEWPORT_UPDATE = "viewport-update", e.ERROR_MESSAGE_DISPLAYED = "error-message-displayed", e.EXITING_GAME = "exiting-game", e.LOCK_PLAY = "lock-play", e.UNLOCK_PLAY = "unlock-play", e.PAUSE_AUTOPLAY = "pause-autoplay", e.TOGGLE_GAME_HELP = "toggle-game-help", e.FREEZE = "freeze", e.UNFREEZE = "unfreeze", e.FREE_ROUNDS_ACTIVATED = "free-rounds-activated", e.SIDE_BET_CHANGED = "side-bet-changed", e.COMMAND_PLAY = "command-play", e.COMMAND_SET_BET = "command-set-bet", e.COMMAND_CONFIRM_CONTINUE = "command-confirm-continue", e.P2P_RC_CHOICE = "rc-choice", e._PAUSE_WHEN_IDLE = "pause-when-idle", e._RESUME = "pause-resume", e._SEND_RCCHOICE = "reality-check-choice", e._NAVIGATE_GAME = "navigate-game", e._INITIALIZED = "feim-initialized";
  }(v || (v = {}));
  var R = "rg_rc_iframe",
    L = ["gameLoaded", "gameLoadedHandler", "gamePausedHandler", "playTimeHandler", "handshakeSuccess", "handshakeCompleted", "handshakeFail", "handshakeFailed"],
    O = void 0,
    h = function () {
      O && (O.style.display = "block");
    },
    m = function () {
      O && (O.style.display = "none");
    },
    N = function () {
      var n, o;
      if (null !== document.body) {
        if (window.removeEventListener("load", N), "true" === E("rcenable")) {
          var t = E("rciframeurl");
          if (void 0 !== t && "" !== t && !t.toLowerCase().includes("javascript:") && (t.startsWith("https:") || t.startsWith("http:"))) {
            var a = document.getElementById(R);
            if (!a) {
              S("Creating RC iframe", e.LogLevel.INIT), (a = document.createElement("iframe")).id = R, a.style.display = "none", a.style.position = "fixed", a.style.left = "0", a.style.top = "0", a.style.width = "100%", a.style.height = "100%", a.style.zIndex = "1001", a.frameBorder = "0", a.setAttribute("sandbox", "allow-scripts allow-top-navigation-by-user-activation allow-same-origin allow-popups allow-popups-to-escape-sandbox");
              var i = document.getElementById("rc_iframe_wrapper");
              i ? i.appendChild(a) : document.body.appendChild(a);
            }
            var r = null !== (n = E("rchistoryurl")) && void 0 !== n ? n : "",
              s = null !== (o = E("homeurl")) && void 0 !== o ? o : "",
              c = t.includes("?") ? "&" : "?";
            a.src = t + c + "rchistoryurl=" + r + "&homeurl=" + s, O = a;
          }
        }
      } else window.addEventListener("load", N);
    },
    y = function (e, n) {
      if (void 0 !== O && O.contentWindow && void 0 !== e) {
        var o,
          t,
          a = e;
        if ((o = a) && ((null === (t = o.rgMessage) || void 0 === t ? void 0 : t.startsWith("gprg_")) || void 0 !== o.method && L.indexOf(o.method) >= 0)) O.contentWindow.postMessage(a, null != n ? n : "*");
      }
    },
    D = function () {
      try {
        return window.self !== window.top;
      } catch (e) {
        return !0;
      }
    }(),
    C = function (e) {
      if (void 0 !== e) {
        var n = c();
        y(e, n), D && window.parent.postMessage(e, n);
      }
    },
    P = [],
    M = [],
    G = void 0,
    b = [],
    U = function (e) {
      void 0 === G && b.push(e);
    },
    w = function (n, o) {
      if (void 0 !== G) return G.processInbound(n, o);
      b.some(function (o) {
        return !!o.checkHandshake(n) && (b.length = 0, S((G = o).name + " set as active", e.LogLevel.INIT), d() && (t = G, P.forEach(function (n) {
          S("Deferred send 🠊", e.LogLevel.ALL_MESSAGES, n), C(t.processOutbound(n.type, n.payload));
        }), P.length = 0), !0);
        var t;
      });
    },
    k = function (e, n) {
      if (void 0 !== G && d()) return G.processOutbound(e, n);
      !function (e, n) {
        e === _.GAME_LOAD_PROGRESS || P.length >= 32 || P.push({
          type: e,
          payload: n
        });
      }(e, n);
    },
    F = new Map(),
    H = function (n) {
      return F.has(n) || F.set(n, []), function (o, t) {
        var a;
        void 0 === t && (t = !1), S("Registering handler for ".concat(n), e.LogLevel.INIT), null === (a = F.get(n)) || void 0 === a || a.push({
          callback: o,
          once: t
        });
      };
    },
    x = function (e) {
      F.forEach(function (n, o) {
        !function (e, n) {
          var o,
            t = null === (o = F.get(e)) || void 0 === o ? void 0 : o.filter(function (e) {
              return e.callback === n;
            });
          void 0 !== t && F.set(e, t);
        }(o, e);
      });
    },
    Y = function (n) {
      var o;
      if (u(n.origin, !0)) {
        var t = w(n.data, n.origin);
        if (void 0 !== t) {
          S("🠈 Received ".concat(t.feimOpEvent), e.LogLevel.ALL_MESSAGES, t.payload);
          var a = null === (o = F.get(t.feimOpEvent)) || void 0 === o ? void 0 : o.filter(function (e) {
            return e.callback(t.payload), !e.once;
          });
          a ? F.set(t.feimOpEvent, a) : I("Warning! The game has no handlers for event ".concat(t.feimOpEvent));
        }
      }
    },
    W = function (e, n) {
      var o;
      null === (o = F.get(e)) || void 0 === o || o.forEach(function (e) {
        e.callback(n);
      });
    },
    B = {
      verifyConfiguration: function () {
        var n = 0;
        S("Checking module configuration ...", e.LogLevel.NONE);
        var o = function (e) {
          I(e), n++;
        };
        return void 0 === r.clientConfig ? o("Configuration missing clientConfig") : void 0 === r.clientConfig.gameServerApi && o("Invalid clientConfig format - not a valid /getclientconfig/ response"), void 0 === r.loginResponse ? o("Configuration missing loginResponse") : void 0 === r.loginResponse.sid && o("Invalid loginResponse format - not a valid login response"), 0 === n ? (S("... Configuration OK", e.LogLevel.NONE), !0) : (S("... Configuration is missing ".concat(n.toString(), " element(s)"), e.LogLevel.NONE), !1);
      }
    },
    j = [],
    K = function (n, o) {
      j.forEach(function (e) {
        e({
          type: n,
          payload: o
        });
      });
      var t = k(n, o);
      void 0 !== t && (S("Sending 🠊", e.LogLevel.ALL_MESSAGES, t), C(t));
    },
    Z = !1,
    V = !1,
    z = void 0,
    J = 0,
    Q = 0,
    X = function () {
      V && (Z && !r.allowMidRoundPause || (V = !1, W(v.FREEZE), K(_.PAUSED, z), z = void 0));
    },
    q = function (e) {
      z = e, V || (V = !0, X());
    },
    $ = function (n) {
      S("Resume triggered with payload", e.LogLevel.ALL_MESSAGES, n), V = !1, W(v.UNFREEZE), K(_.RESUMING_AFTER_PAUSE, n);
    },
    ee = function () {
      var e;
      if (f("rcinterval") && f("rciframeurl")) {
        var n = Number(E("rcinterval"));
        if (!(isNaN(n) || n <= 0) && 0 === J) {
          J = Date.now(), Q = Number(null !== (e = E("rcelapsed")) && void 0 !== e ? e : 0);
          var o = 1e3,
            t = function () {
              var e = Q + Math.round((Date.now() - J) / o);
              K(_.REPORT_SESSION_DETAILS, {
                sessionTime: e
              }), q({
                realityCheck: !0
              }), setTimeout(t, n * o);
            };
          setTimeout(t, (0 === Q ? n : n - Q % n) * o);
        }
      }
    },
    ne = {},
    oe = function (e, n) {
      C({
        method: e,
        params: n
      });
    },
    te = function () {
      function n() {
        this.name = "Legacy RC", oe("gameLoadedHandler");
      }
      return n.prototype.checkHandshake = function (n) {
        var o = n;
        if ("operatorLoaded" === o.method) oe("gameLoadedHandler");else if ("confirmHandshake" === o.method) return S("Using direct Legacy PostMessage API connection", e.LogLevel.INIT), ee(), void 0 !== o.params.success && oe(o.params.success), W(v._INITIALIZED), !0;
        return !1;
      }, n.prototype.processInbound = function (e) {
        var n, o;
        if (void 0 !== e) {
          var t = e;
          if (void 0 !== t.method) switch (t.method) {
            case "pauseGame":
              return ne.gamePausedCallback = null === (n = t.params) || void 0 === n ? void 0 : n.callback, {
                feimOpEvent: v._PAUSE_WHEN_IDLE,
                payload: {
                  realityCheck: !0
                }
              };
            case "resumeGame":
              return ne.gameResumedCallback = null === (o = t.params) || void 0 === o ? void 0 : o.callback, {
                feimOpEvent: v._RESUME
              };
            case "navigateTo":
              var a = t.params;
              return {
                feimOpEvent: v._NAVIGATE_GAME,
                payload: a
              };
          }
        }
      }, n.prototype.processOutbound = function (e, n) {
        switch (e) {
          case _.PAUSED:
            return h(), void 0 !== ne.gamePausedCallback ? {
              method: ne.gamePausedCallback
            } : void 0;
          case _.RESUMING_AFTER_PAUSE:
            return m(), void 0 !== ne.gameResumedCallback ? {
              method: ne.gameResumedCallback
            } : void 0;
          case _.REPORT_SESSION_DETAILS:
            return {
              method: "playTimeHandler",
              params: {
                delay: n.sessionTime
              }
            };
          default:
            return;
        }
      }, n;
    }(),
    ae = "1.17.1",
    ie = 0,
    re = function (e, n) {
      C({
        rgMessage: e,
        payload: n
      });
    },
    se = function () {
      function n() {
        this.name = "Rg PostMessage API", re("gprg_Listening");
      }
      return n.prototype.checkHandshake = function (n) {
        return "oprg_Ready" === n.rgMessage && (S("Using direct Rg PostMessage API connection", e.LogLevel.INIT), ee(), re("gprg_Ready"), W(v._INITIALIZED), !0);
      }, n.prototype.processInbound = function (e) {
        if (void 0 !== e) {
          var n = e;
          if (void 0 !== n.rgMessage && n.rgMessage.includes("oprg_")) switch (n.rgMessage) {
            case "oprg_GamePause":
              return void 0 !== n.payload ? !0 === (o = n.payload).autoPlayOnly ? {
                feimOpEvent: v.PAUSE_AUTOPLAY
              } : {
                feimOpEvent: v._PAUSE_WHEN_IDLE,
                payload: o
              } : {
                feimOpEvent: v._PAUSE_WHEN_IDLE
              };
            case "oprg_GameResume":
              var o = n.payload;
              return {
                feimOpEvent: v._RESUME,
                payload: o
              };
            case "oprg_NavigateGame":
              o = n.payload;
              return {
                feimOpEvent: v._NAVIGATE_GAME,
                payload: o
              };
            case "oprg_DebugSettings":
              re("gprg_DebugSettings", {
                id: "Using FEIM v".concat(ae)
              });
              break;
            case "oprg_DebugErrors":
              re("gprg_DebugErrors", []);
              break;
            case "oprg_Ping":
              void 0 !== (null == (o = n.payload) ? void 0 : o.id) ? re("gprg_Pong", {
                id: o.id
              }) : re("gprg_Pong");
              break;
            case "oprg_UpdateBalance":
              return {
                feimOpEvent: v.REFRESH_BALANCE
              };
            case "oprg_SetSounds":
              o = n.payload;
              return {
                feimOpEvent: v.UPDATE_SETTINGS,
                payload: {
                  sounds: o.enableSounds
                }
              };
            case "oprg_GetSoundState":
              break;
            default:
              I("Unhandled rgMessage ".concat(n.rgMessage));
          }
        }
      }, n.prototype.processOutbound = function (e, n) {
        switch (e) {
          case _.LISTENING:
          case _.HELLO:
          case _.CONFIGURE:
          case _.REALITY_CHECK_RESOLVED:
            return;
          case _.PAUSED:
            return (null == (o = n) ? void 0 : o.realityCheck) && h(), {
              rgMessage: "gprg_GamePaused",
              payload: o
            };
          case _.RESUMING_AFTER_PAUSE:
            return (null == (o = n) ? void 0 : o.realityCheck) && m(), {
              rgMessage: "gprg_GameResumed",
              payload: o
            };
          case _.GAME_LOAD_STARTED:
          case _.GAME_LOAD_PROGRESS:
            return;
          case _.GAME_LOAD_COMPLETED:
            return {
              rgMessage: "gprg_GameReady"
            };
          case _.ROUND_STARTED:
            var o = void 0;
            return void 0 !== (null == (t = n) ? void 0 : t.balance) ? o = {
              balance: t.balance
            } : ie >= 0 && (o = {
              balance: ie
            }), {
              rgMessage: "gprg_GameRoundStart",
              payload: o
            };
          case _.ROUND_FINISHED:
            var t;
            o = void 0;
            return void 0 !== (null == (t = n) ? void 0 : t.balance) ? o = {
              balance: t.balance
            } : ie >= 0 && (o = {
              balance: ie
            }), {
              rgMessage: "gprg_GameRoundEnd",
              payload: o
            };
          case _.ROUND_RESUMED:
          case _.FEATURE_STARTED:
          case _.FEATURE_FINISHED:
          case _.AUTOPLAY_STARTED:
          case _.AUTOPLAY_FINISHED:
          case _.REQUEST_VIEWPORT_CONFIG:
            return;
          case _.BALANCE_UPDATE:
            return void (ie = n);
          case _.BET_UPDATE:
          case _.WIN_UPDATE:
            return;
          case _.UPDATE_SETTINGS:
            return {
              rgMessage: "gprg_Settings",
              payload: o = {
                enableSounds: n.sounds
              }
            };
          case _.ERROR_MESSAGE:
          case _.EXIT_GAME:
          case _.GOTO_GAME:
            return;
          case _.OPEN_QUICK_DEPOSIT:
            return {
              rgMessage: "gprg_OpenQuickDeposit"
            };
          case _.REPORT_SESSION_DETAILS:
            return {
              rgMessage: "gprg_RealityCheckData",
              payload: n
            };
          case _.USER_ACTION:
            return {
              rgMessage: "gprg_UserAction",
              payload: n
            };
          case _.REPORT_UI_STATE:
          case _.JACKPOT_ANIMATION_STARTED:
          case _.JACKPOT_ANIMATION_FINISHED:
          case _.GAME_READY_TO_PLAY:
            return;
        }
      }, n;
    }();
  var ce,
    ue = !1,
    de = function (e) {
      ue || (H(v._SEND_RCCHOICE)(function (n) {
        var a;
        if (void 0 === e.clientConfig || void 0 === (null === (a = e.loginResponse) || void 0 === a ? void 0 : a.sid)) return W(v.P2P_RC_CHOICE, n), void ("continue" === n.action && K(_.REALITY_CHECK_RESOLVED));
        (function (e, n) {
          return o(this, void 0, void 0, function () {
            var o, a, i;
            return t(this, function (t) {
              switch (t.label) {
                case 0:
                  o = {
                    method: "POST",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json"
                    }
                  }, n && (o.body = JSON.stringify(n)), a = void 0, t.label = 1;
                case 1:
                  return t.trys.push([1, 3,, 4]), [4, fetch(e, o)];
                case 2:
                  return a = t.sent(), [3, 4];
                case 3:
                  return i = t.sent(), console.error(i), [2];
                case 4:
                  if (200 !== a.status) throw new Error("".concat(a.status.toString(), ": Fetch failed (").concat(e, ")"));
                  return [4, a.json()];
                case 5:
                  return [2, t.sent()];
              }
            });
          });
        })("".concat(e.clientConfig.gameServerApi, "/rcchoice"), {
          sid: e.loginResponse.sid,
          choice: n.action
        }).then(function () {
          "continue" === n.action && K(_.REALITY_CHECK_RESOLVED);
        }).catch(function (e) {
          T("Failed to send rcchoice");
        });
      }), ue = !0);
    },
    le = [v.COMMAND_PLAY, v.COMMAND_SET_BET, v.COMMAND_CONFIRM_CONTINUE],
    Ee = function () {
      function n() {
        this.name = "Theos API", S("Starting Theos handshake ...", e.LogLevel.INIT), C(this.processOutbound(_.LISTENING));
      }
      return n.prototype.checkHandshake = function (n) {
        var o = n;
        if (o.feimOpEvent === v.LISTENING) {
          S("... saying hello ...", e.LogLevel.INIT);
          var t = {
            feimVersion: ae
          };
          C(this.processOutbound(_.HELLO, t)), de(r);
        } else if (o.feimOpEvent === v.HELLO) {
          var a = o.payload;
          return S("... THEOS handshake complete", e.LogLevel.INIT), a.handlesErrors ? (S("Error messages are handled by the operator", e.LogLevel.INIT), r.operatorHandlesErrors = !0) : r.operatorHandlesErrors = !1, a.handlesExit && (S("Game exiting is handled by the operator", e.LogLevel.INIT), r.operatorHandlesGameExit = !0), r.externalFreeRoundsMessages = !0 === a.handlesFreeRoundsMessages, W(v._INITIALIZED), !0;
        }
        return !1;
      }, n.prototype.processInbound = function (n, o) {
        if (void 0 !== n.feimOpEvent) {
          var t = n;
          return le.includes(t.feimOpEvent) && !u(o, !1) ? void I("Message from ".concat(o, " was blocked (").concat(t.feimOpEvent, ") - not an accepted origin"), e.LogLevel.WARN) : t;
        }
      }, n.prototype.processOutbound = function (e, n) {
        var o = {
          feimGameEvent: e
        };
        return void 0 !== n && (o.payload = n), o;
      }, n;
    }(),
    fe = !1,
    ge = !1,
    pe = function (o, t) {
      var a;
      S("Assigning config:", e.LogLevel.INIT, Object.keys(o)), S("Config content:", e.LogLevel.ALL_MESSAGES_AND_PAYLOADS, o), Object.assign(t, o), !ge && !0 === t.handleRgPostMessageAPI && d() && (ge = !0, U(new se()), U(new te())), !fe && d() && (fe = !0, U(new Ee()), M.forEach(function (e) {
        var n = e.event;
        (0, e.handler)(n);
      }), M.length = 0);
      var i = o.gettokenResponse,
        s = o.loginResponse;
      if ("ok" === (null == i ? void 0 : i.status) && void 0 !== i.response) {
        var u = i.response,
          l = {
            gettokenResponse: {
              replaytoken: u.replaytoken,
              servertime: u.servertime,
              widget: u.widget
            }
          };
        K(_.CONFIGURE, l);
      }
      try {
        if (void 0 !== s) {
          var f = n({}, s);
          ("true" !== E("beyondplay") && !0 !== (null === (a = t.clientConfig) || void 0 === a ? void 0 : a.sendSid) || !function () {
            var e;
            return !0 === (null === (e = r.clientConfig) || void 0 === e ? void 0 : e.devMode) || "*" !== c() && "-" !== c();
          }()) && (f.sid = "");
          l = {
            currencyCode: s.stats.currency,
            specialSessionConfig: s.specialSessionConfig,
            loginResponse: f
          };
          K(_.CONFIGURE, l);
        }
      } catch (e) {
        T("Invalid login response");
      }
      if (void 0 !== o.p2pConfig) {
        l = {
          currencyCode: o.p2pConfig.currency,
          specialSessionConfig: o.p2pConfig.specialSessionConfig
        };
        K(_.CONFIGURE, l);
      }
      o.handleFeaturePause && K(_.CONFIGURE, {
        handleFeaturePause: o.handleFeaturePause
      });
    },
    _e = function (e) {
      if (void 0 === e || "" === e) return !1;
      var n = "action:";
      if (!e.startsWith(n)) return !1;
      var o = e.slice(7);
      return K(_.USER_ACTION, {
        action: o
      }), !0;
    },
    ve = function (e) {
      return void 0 !== e && "" !== e && (_e(e) || (window.location.href = e), !0);
    },
    Ae = Object.freeze({
      __proto__: null,
      autoPlayFinished: function () {
        K(_.AUTOPLAY_FINISHED);
      },
      autoPlayStarted: function () {
        K(_.AUTOPLAY_STARTED);
      },
      balanceUpdate: function (e) {
        K(_.BALANCE_UPDATE, e);
      },
      betUpdate: function (e) {
        K(_.BET_UPDATE, e);
      },
      errorMessage: function (e) {
        return K(_.ERROR_MESSAGE, e), !!r.operatorHandlesErrors;
      },
      exitGame: function () {
        var e;
        if (K(_.EXIT_GAME), !r.operatorHandlesGameExit) {
          var n = E("homeurl");
          if (ve(n)) return !0;
          if (null === (e = r.clientConfig) || void 0 === e ? void 0 : e.buttonEventsIframe) return C("closeGame"), !0;
          if (void 0 === n || "" === n) return window.history.length > 1 && (window.history.back(), !0);
        }
        return !0;
      },
      featureFinished: function (e) {
        K(_.FEATURE_FINISHED, e);
      },
      featureStarted: function (e) {
        K(_.FEATURE_STARTED, e);
      },
      gameLoadCompleted: function () {
        K(_.GAME_LOAD_COMPLETED);
      },
      gameLoadProgress: function (e) {
        K(_.GAME_LOAD_PROGRESS, e);
      },
      gameLoadStarted: function () {
        K(_.GAME_LOAD_STARTED);
      },
      gameReadyToPlay: function () {
        K(_.GAME_READY_TO_PLAY);
      },
      goToGame: function (e) {
        return K(_.GOTO_GAME, e), !0;
      },
      jackpotResolved: function () {
        K(_.JACKPOT_ANIMATION_FINISHED);
      },
      navigate: ve,
      openQuickDeposit: function () {
        K(_.OPEN_QUICK_DEPOSIT);
      },
      reportUIState: function (e) {
        K(_.REPORT_UI_STATE, e);
      },
      roundFinished: function (e) {
        var o = e;
        if (void 0 !== (null == e ? void 0 : e.playResponse)) {
          var t = e.playResponse,
            a = t.roundType,
            i = t.stats,
            r = t.roundId,
            s = t.ba,
            c = t.win,
            u = t.ended,
            d = t.messages;
          o = n(n({}, e), {
            playResponse: {
              roundType: a,
              stats: i,
              roundId: r,
              ba: s,
              win: c,
              ended: u,
              messages: d
            }
          });
        }
        K(_.ROUND_FINISHED, o);
      },
      roundResumed: function (e) {
        K(_.ROUND_RESUMED, e);
      },
      roundStarted: function (e) {
        K(_.ROUND_STARTED, e);
      },
      showHistory: function () {
        var e,
          n,
          o = E("rchistoryurl");
        _e(o) || (void 0 === (n = o) || "" === n || !n.toLowerCase().startsWith("http:") && !n.toLowerCase().startsWith("https:") || (window.open(n, "_blank"), 0)) && (null === (e = r.clientConfig) || void 0 === e ? void 0 : e.buttonEventsIframe) && C("showHistory");
      },
      updateSettings: function (e) {
        K(_.UPDATE_SETTINGS, e);
      },
      winUpdate: function (e) {
        K(_.WIN_UPDATE, e);
      }
    }),
    Se = function (e) {
      H(v.ERROR_MESSAGE_DISMISSED)(e);
    },
    Ie = Object.freeze({
      __proto__: null,
      confirmedContinue: function (e) {
        H(v.COMMAND_CONFIRM_CONTINUE)(e);
      },
      errorMessageDismissed: Se,
      errorMessageDisplayed: function (e) {
        H(v.ERROR_MESSAGE_DISPLAYED)(e);
      },
      exitingGame: function (e) {
        H(v.EXITING_GAME)(e);
      },
      freeRoundsActivated: function (e) {
        H(v.FREE_ROUNDS_ACTIVATED)(e);
      },
      freeze: function (e) {
        H(v.FREEZE)(e);
      },
      initialized: function (e) {
        void 0 !== r.operatorHandlesErrors ? e() : H(v._INITIALIZED)(e);
      },
      lockPlay: function (e) {
        H(v.LOCK_PLAY)(e);
      },
      pauseAutoPlay: function (e) {
        H(v.PAUSE_AUTOPLAY)(e);
      },
      playRound: function (e) {
        H(v.COMMAND_PLAY)(e);
      },
      refreshBalance: function (e) {
        H(v.REFRESH_BALANCE)(e);
      },
      setBet: function (e) {
        H(v.COMMAND_SET_BET)(e);
      },
      sideBetChanged: function (e) {
        H(v.SIDE_BET_CHANGED)(e);
      },
      toggleGameHelp: function (e) {
        H(v.TOGGLE_GAME_HELP)(e);
      },
      togglePaytable: function (e) {
        H(v.PAYTABLE_TOGGLE)(e);
      },
      unfreeze: function (e) {
        H(v.UNFREEZE)(e);
      },
      unlockPlay: function (e) {
        H(v.UNLOCK_PLAY)(e);
      },
      updateSettings: function (e) {
        H(v.UPDATE_SETTINGS)(e);
      }
    }),
    Te = Object.freeze({
      __proto__: null,
      onRealityCheckChoiceRequired: function (e) {
        H(v.P2P_RC_CHOICE)(e);
      }
    });
  window.rlxfeim = {
    verifyConfiguration: B.verifyConfiguration,
    log: []
  }, window.addEventListener("message", function (e) {
    d() ? Y(e) : function (e, n) {
      M.length >= 32 || M.push({
        event: e,
        handler: n
      });
    }(e, Y);
  }), ce = function (e) {
    e.type === _.ROUND_STARTED ? Z = !0 : e.type === _.ROUND_FINISHED && (Z = !1, X());
  }, j.push(ce), H(v._PAUSE_WHEN_IDLE)(q), H(v._RESUME)($), H(v._NAVIGATE_GAME)(function (e) {
    void 0 !== e.url && (e.url.toLowerCase().startsWith("http:") || e.url.toLowerCase().startsWith("https:")) && (window.location.href = e.url);
  }), N(), e.P2P = Te, e.configure = function (e) {
    var n;
    n = e.logLevel, g || void 0 === n || (p = n), pe(e, s());
  }, e.debug = B, e.getConfiguration = s, e.on = Ie, e.remove = function (e) {
    x(e);
  }, e.send = Ae, e.showError = function (n) {
    return o(void 0, void 0, void 0, function () {
      return t(this, function (o) {
        return [2, new Promise(function (o, t) {
          if (void 0 === r.showErrorMessageCallback) return S("showErrorMessageCallback is not defined", e.LogLevel.WARN), void t();
          r.operatorHandlesErrors ? (S("Showing remote error message"), K(_.ERROR_MESSAGE, n), W(v.FREEZE), Se(function () {
            W(v.UNFREEZE), o();
          })) : (W(v.FREEZE), Promise.resolve(r.showErrorMessageCallback(n)).then(function (e) {
            W(v.UNFREEZE), o(e);
          }).catch(function (e) {
            W(v.UNFREEZE), t(e);
          }));
        })];
      });
    });
  };
});
